module.exports = __webpack_public_path__ + "static/media/7.6e1b3caa.JPG";